import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=4deecdf9&scoped=true"
import script from "./NewsletterModal.vue?vue&type=script&lang=ts"
export * from "./NewsletterModal.vue?vue&type=script&lang=ts"
import style0 from "./NewsletterModal.vue?vue&type=style&index=0&id=4deecdf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deecdf9",
  null
  
)

export default component.exports